import type { TimeSlot, TimeSlotData, CookingTimeTranslations } from './types';
import { getBarColor, getBarWidth } from './constants';

interface TimeSlotBarProps {
  timeSlot: TimeSlot;
  data: TimeSlotData;
  t: CookingTimeTranslations;
}

export function TimeSlotBar({ timeSlot, data, t }: TimeSlotBarProps) {
  const colors = getBarColor(data.time);

  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <span className="text-[clamp(11px,2.8vw,13px)] text-muted-foreground">
          {t.timeSlots[timeSlot]}
        </span>
        <div className="flex items-center gap-2">
          <span className={`text-[clamp(11px,2.8vw,13px)] ${colors.text}`}>
            {data.time}{t.minutes}
          </span>
        </div>
      </div>
      <div className="relative">
        <div className="w-full h-1.5 bg-muted rounded-full overflow-hidden">
          <div
            className={`h-full rounded-full ${colors.bg}`}
            style={{ width: `${getBarWidth(data.time)}%` }}
          />
        </div>
      </div>
    </div>
  );
}
